import '../styles/entry-count-component.css'
import React from 'react';

class EntryCountComponent extends React.Component {

    /*
        This is a helper function to get the text to display for the entry count
    */
    getText = () => {
        let text = null;
        if(this.props.timelineCount === 0)
            text = "No significant wildfires have been recorded for this area.";
        else if(this.props.timelineCount === 1)
            text = "1 significant wildfire has been recorded for this area.";
        else
            text = `${this.props.timelineCount} significant wildfires have been recorded for this area.`;
        return text;
    }

    render = () => {
        return (
            <div className='address-display Oswald no-print'>
                <h2 className={ ( this.props.zoomIn ? '' : 'hidden ') + 'Oswald gappyText'}>Enter an address or zoom in to begin</h2>
                <h2 className={!this.props.searching && !this.props.zoomIn ? '' : 'hidden' }>{this.getText()}</h2>
            </div>
        )
    }
}


export default EntryCountComponent;